function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20,
  rx: 10,
  fill: "transparent"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4576_1395)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.29948 14.9266L3.95111 15.9571C3.74494 16.1147 3.70554 16.4096 3.86309 16.6157C3.9556 16.7367 4.09535 16.8003 4.23677 16.8003C4.33625 16.8003 4.43654 16.7688 4.52172 16.7037L5.87009 15.6733C6.07626 15.5157 6.11567 15.2208 5.95811 15.0146C5.80056 14.8085 5.50568 14.7691 5.29948 14.9266Z",
  fill: "#A67C52"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.0638 15.9571L13.7155 14.9266C13.5093 14.7691 13.2144 14.8085 13.0568 15.0146C12.8993 15.2208 12.9387 15.5157 13.1449 15.6733L14.4932 16.7037C14.5784 16.7688 14.6787 16.8003 14.7782 16.8003C14.9196 16.8003 15.0594 16.7367 15.1518 16.6157C15.3094 16.4096 15.27 16.1147 15.0638 15.9571Z",
  fill: "#A67C52"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.5075 3.98486C5.91927 3.98486 3 6.9041 3 10.4924C3 14.0806 5.91924 16.9999 9.5075 16.9999C13.0958 16.9999 16.015 14.0806 16.015 10.4923C16.015 6.90408 13.0957 3.98486 9.5075 3.98486Z",
  fill: "#DBAD75"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.5075 3.98486C5.91927 3.98486 3 6.9041 3 10.4924C3 14.0806 5.91924 16.9999 9.5075 16.9999V3.98486Z",
  fill: "#EABD81"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.50751 5.19873C6.58852 5.19873 4.21375 7.5735 4.21375 10.4925C4.21375 13.4115 6.58852 15.7863 9.50751 15.7863C12.4265 15.7863 14.8013 13.4115 14.8013 10.4925C14.8013 7.5735 12.4265 5.19873 9.50751 5.19873Z",
  fill: "#BC2A46"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.50751 5.19873C6.58852 5.19873 4.21375 7.5735 4.21375 10.4925C4.21375 13.4115 6.58852 15.7863 9.50751 15.7863V5.19873Z",
  fill: "#D62D46"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.5075 6.90381C7.52872 6.90381 5.91888 8.51364 5.91888 10.4924C5.91888 12.4712 7.52872 14.081 9.5075 14.081C11.4863 14.081 13.0961 12.4712 13.0961 10.4924C13.0961 8.51364 11.4863 6.90381 9.5075 6.90381Z",
  fill: "#DBAD75"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.5075 6.90381C7.52872 6.90381 5.91888 8.51364 5.91888 10.4924C5.91888 12.4712 7.52872 14.081 9.5075 14.081V6.90381Z",
  fill: "#EABD81"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.50751 8.73584C8.53881 8.73584 7.75073 9.52391 7.75073 10.4926C7.75073 11.4613 8.53881 12.2494 9.50751 12.2494C10.4762 12.2494 11.2643 11.4613 11.2643 10.4926C11.2643 9.52391 10.4762 8.73584 9.50751 8.73584Z",
  fill: "#BC2A46"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.50751 8.73584C8.53881 8.73584 7.75073 9.52391 7.75073 10.4926C7.75073 11.4613 8.53881 12.2494 9.50751 12.2494V8.73584Z",
  fill: "#D62D46"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.50751 10.9624C9.38725 10.9624 9.267 10.9166 9.17529 10.8248C8.99178 10.6413 8.99178 10.3438 9.17529 10.1603L15.2688 4.06683C15.4523 3.88332 15.7498 3.88332 15.9333 4.06683C16.1168 4.25033 16.1168 4.5478 15.9333 4.73131L9.83977 10.8248C9.748 10.9166 9.62774 10.9624 9.50751 10.9624Z",
  fill: "#CFCDD6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.50751 10.9624C9.38725 10.9624 9.267 10.9165 9.17529 10.8248C8.99178 10.6413 8.99178 10.3438 9.17529 10.1603L12.0895 7.24609L12.7539 7.91057L9.83977 10.8248C9.748 10.9165 9.62774 10.9624 9.50751 10.9624Z",
  fill: "#DEE1E7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.5106 5.87844H14.5915C14.332 5.87844 14.1216 5.66806 14.1216 5.40856V4.48941C14.1216 4.22991 14.332 4.01953 14.5915 4.01953C14.851 4.01953 15.0614 4.22991 15.0614 4.48941V4.93872H15.5106C15.7701 4.93872 15.9805 5.1491 15.9805 5.40859C15.9805 5.66808 15.7701 5.87844 15.5106 5.87844Z",
  fill: "#39B7B6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.0204 5.36864H15.1013C14.8418 5.36864 14.6314 5.15826 14.6314 4.89877V3.97964C14.6314 3.72015 14.8418 3.50977 15.1013 3.50977C15.3607 3.50977 15.5711 3.72015 15.5711 3.97964V4.42892H16.0204C16.2799 4.42892 16.4903 4.63931 16.4903 4.8988C16.4903 5.15829 16.2799 5.36864 16.0204 5.36864Z",
  fill: "#FBB03B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.5301 4.85888H15.611C15.3515 4.85888 15.1411 4.6485 15.1411 4.389V3.46987C15.1411 3.21038 15.3515 3 15.611 3C15.8705 3 16.0809 3.21038 16.0809 3.46987V3.91916H16.5301C16.7896 3.91916 17 4.12954 17 4.38903C17 4.64852 16.7896 4.85888 16.5301 4.85888Z",
  fill: "#39B7B6"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4576_1395"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "white",
  transform: "translate(3 3)"
})));

var SvgDarts = function SvgDarts(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDarts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/darts.6ad1e011.svg";
export { ForwardRef as ReactComponent };